import { CircularProgress, Grid, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { monthlyDisbursedData } from "../../api";
import { cf } from "../../utility/Formater";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const monthsMap = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

function stringToColor(str, opacity = 0.2) {
  const hash = Array.from(str).reduce(
    (hash, char) => (char.charCodeAt(0) + (hash << 5) - hash) & 0xffffff,
    0
  );

  const hexColor = `#${(hash & 0xffffff).toString(16).padStart(6, "0")}`;
  const rgbaColor = `rgba(${(hash & 0xff0000) >> 16}, ${
    (hash & 0x00ff00) >> 8
  }, ${hash & 0x0000ff}, ${opacity})`;

  return rgbaColor;
}

export default function NachDashboardTrans({ nachData, loader }) {
  const [monthlyData, setMonthlyData] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const [months, setMonths] = useState([]);

  useEffect(() => {
    if (Array?.isArray(nachData) && nachData?.length > 0) {
      let data = nachData;
      let total = data.pop();
      setMonthlyData(data);
      setTotalData(total);
      setMonths(data[0]?.monthlyData);
    } else {
      setMonthlyData([]);
    }
  }, [nachData]);

  const handleDownloadCsv = () => {
    let csvContent = `,,Total,,`;

    let columns = "";
    monthlyData.map((edx) => {
      csvContent += `,${(edx?.nbfc_name || "NA")?.split(" ")?.[0]},,`;
      columns += "Total Collection(Txn),Nach Collection(Txn),%,";
    });

    csvContent +=
      "\nTxn Month,Total Collection(Txn),Nach Collection(Txn),%," + columns;

    let totalsRow = "";
    months?.map((m, i) => {
      csvContent += `\n${m?.month}/${m?.year},`;
      csvContent += `${Math.round(
        totalData?.monthlyData?.[i]?.totalTransactionAmt
      )} (${totalData?.monthlyData?.[i]?.totalTransactions}),${Math.round(
        totalData?.monthlyData?.[i]?.nachTransactionsAmt
      )} (${totalData?.monthlyData?.[i]?.nachTransactions}),${
        totalData?.monthlyData?.[i]?.amtPercentage
      } (${totalData?.monthlyData?.[i]?.countPercentage}),`;
      if (i === months?.length - 1) {
        totalsRow = `Grand Total,${Math.round(
          totalData?.totalTransactionAmt
        )} (${totalData?.totalTransactions}),${Math.round(
          totalData?.nachTransactionsAmt
        )} (${totalData?.nachTransactions}),${totalData?.amtPercentage} (${
          totalData?.countPercentage
        }),`;
      }
      monthlyData.map((d) => {
        let edx = d?.monthlyData?.[i];
        csvContent += `${Math.round(edx?.totalTransactionAmt)} (${
          edx?.totalTransactions
        }),${Math.round(edx?.nachTransactionsAmt)} (${edx?.nachTransactions}),${
          edx?.amtPercentage
        } (${edx?.countPercentage}),`;
        totalsRow += `${Math.round(d?.totalTransactionAmt)} (${
          d?.totalTransactions
        }),${Math.round(d?.nachTransactionsAmt)} (${d?.nachTransactions}),${
          d?.amtPercentage
        } (${d?.countPercentage}),`;
      });
    });

    csvContent += `\n${totalsRow}`;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, "nach-transactions");
    } else {
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "nach-transactions");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  return (
    <>
      <div
        style={{ overflow: "scroll", maxHeight: "80vh", maxWidth: "100%" }}
        // className="custom-table"
      >
        {loader === "NACH" ? (
          <div style={styles?.loading_container}>
            <CircularProgress color="inherit" />
          </div>
        ) : monthlyData?.length > 0 ? (
          <table style={styles?.table}>
            <thead style={styles?.thead}>
              <tr>
                <th style={styles?.th_top_months}> </th>
                <th
                  style={{
                    ...styles?.th_top_nbfcs,
                    background: "#adacac",
                  }}
                >
                  Total
                </th>
                {monthlyData.map((edx) => {
                  // console.log(edx);
                  return (
                    <th
                      style={{
                        ...styles?.th_top_nbfcs,
                        background: stringToColor(edx?.nbfc_name, 0.5),
                      }}
                    >
                      {(edx?.nbfc_name || "NA")?.split(" ")?.[0]}
                    </th>
                  );
                })}
              </tr>
              <tr>
                <th style={styles?.th_secondary}>Txn Month</th>
                <th
                  style={{
                    background: "#adacac",
                  }}
                >
                  <th
                    style={{
                      ...styles?.th_secondary,
                    }}
                  >
                    Total Collection(Txn)
                  </th>
                  <th
                    style={{
                      width: "250px",
                      textAlign: "center",
                      fontSize: "12px",
                      borderRight: "1px solid",
                      color: "#0000008c",
                    }}
                  >
                    Nach Collection(Txn)
                  </th>
                  <th
                    style={{
                      width: "250px",
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#0000008c",
                    }}
                  >
                    %
                  </th>
                </th>

                {monthlyData.map((edx) => {
                  return (
                    <th
                      style={{
                        ...styles?.th_top_nbfcs,
                        background: stringToColor(edx?.nbfc_name),
                      }}
                    >
                      <th
                        style={{
                          width: "250px",
                          textAlign: "center",
                          fontSize: "12px",
                          color: "#0000008c",
                          borderRight: "1px solid",
                        }}
                      >
                        Total Collection(Txn)
                      </th>
                      <th
                        style={{
                          width: "250px",
                          textAlign: "center",
                          fontSize: "12px",
                          color: "#0000008c",
                          borderRight: "1px solid",
                        }}
                      >
                        Nach Collection(Txn)
                      </th>
                      <th
                        style={{
                          width: "250px",
                          textAlign: "center",
                          fontSize: "12px",
                          color: "#0000008c",
                        }}
                      >
                        %
                      </th>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ ...styles?.th_top_months }}>
                  {months?.map((edx, index) => {
                    return (
                      <tr>
                        <td align="center" style={{ minWidth: "125px" }}>
                          {monthsMap[edx?.month]},
                          {edx?.year.toString().slice(2, 4)}
                        </td>
                      </tr>
                    );
                  })}
                </td>
                <td
                  style={{
                    ...styles?.th_top_nbfcs,
                    background: "#e8e8e8",
                  }}
                >
                  <td
                    align="center"
                    style={{
                      borderRight: "1px solid",
                      width: "250px",
                    }}
                  >
                    {totalData?.monthlyData?.map((val) => {
                      return (
                        <tr>
                          <td align="center">
                            {cf(Math.round(val["totalTransactionAmt"]))}{" "}
                            <span style={styles.count}>
                              ({val?.totalTransactions})
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </td>
                  <td
                    align="center"
                    style={{
                      borderRight: "1px solid",
                      width: "250px",
                    }}
                  >
                    {totalData?.monthlyData?.map((val) => {
                      return (
                        <tr>
                          <td align="center">
                            {cf(Math.round(val["nachTransactionsAmt"]))}{" "}
                            <span style={styles.count}>
                              ({val?.nachTransactions})
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </td>

                  <td
                    align="center"
                    style={{
                      width: "250px",
                    }}
                  >
                    {totalData?.monthlyData?.map((val) => {
                      return (
                        <tr>
                          <td align="center">
                            {val["amtPercentage"]}{" "}
                            <span style={styles.count}>
                              ({val?.countPercentage})
                            </span>
                          </td>
                        </tr>
                      );
                    })}{" "}
                  </td>
                </td>
                {monthlyData.map((edx, i) => {
                  return (
                    <td
                      style={{
                        ...styles?.th_top_nbfcs,
                        background: stringToColor(edx?.nbfc_name),
                      }}
                    >
                      <td
                        align="center"
                        style={{
                          borderRight: "1px solid",
                          width: "250px",
                        }}
                      >
                        {edx?.monthlyData?.map((val) => {
                          return (
                            <tr>
                              <td align="center">
                                {cf(Math.round(val["totalTransactionAmt"]))}{" "}
                                <span style={styles.count}>
                                  ({val?.totalTransactions})
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </td>

                      <td
                        align="center"
                        style={{
                          width: "250px",
                          borderRight: "1px solid",
                        }}
                      >
                        {edx?.monthlyData?.map((val) => {
                          return (
                            <tr>
                              <td align="center">
                                {cf(Math.round(val["nachTransactionsAmt"]))}{" "}
                                <span style={styles.count}>
                                  ({val?.nachTransactions})
                                </span>
                              </td>
                            </tr>
                          );
                        })}{" "}
                      </td>

                      <td
                        align="center"
                        style={{
                          width: "250px",
                        }}
                      >
                        {edx?.monthlyData?.map((val) => {
                          return (
                            <tr>
                              <td align="center">
                                {val["amtPercentage"]}{" "}
                                <span style={styles.count}>
                                  ({val?.countPercentage})
                                </span>
                              </td>
                            </tr>
                          );
                        })}{" "}
                      </td>
                    </td>
                  );
                })}
              </tr>
              <tr>
                <th style={{ fontSize: "14px", textAlign: "center" }}>
                  Grand Total
                </th>
                <th
                  style={{
                    ...styles?.th_top_nbfcs,
                    background: "#e8e8e8",
                  }}
                >
                  <th
                    style={{
                      width: "250px",
                      textAlign: "center",
                      fontSize: "14px",
                      borderRight: "1px solid",
                    }}
                  >
                    {cf(Math.round(totalData?.totalTransactionAmt))}{" "}
                    <span style={styles.count}>
                      ({totalData?.totalTransactions})
                    </span>
                  </th>
                  <th
                    style={{
                      width: "250px",
                      textAlign: "center",
                      fontSize: "14px",
                      borderRight: "1px solid",
                    }}
                  >
                    {cf(Math.round(totalData?.nachTransactionsAmt))}{" "}
                    <span style={styles.count}>
                      ({totalData?.nachTransactions})
                    </span>
                  </th>
                  <th
                    style={{
                      width: "250px",
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    {totalData?.amtPercentage}{" "}
                    <span style={styles.count}>
                      ({totalData?.countPercentage})
                    </span>
                  </th>
                </th>
                {monthlyData.map((edx) => {
                  return (
                    <th
                      style={{
                        ...styles?.th_top_nbfcs,
                        background: stringToColor(edx?.nbfc_name),
                      }}
                    >
                      <th
                        style={{
                          width: "250px",
                          textAlign: "center",
                          fontSize: "14px",
                          color: "rgb(16 16 16 / 89%)",
                          borderRight: "1px solid",
                        }}
                      >
                        {cf(Math.round(edx?.totalTransactionAmt))}{" "}
                        <span style={styles.count}>
                          ({edx?.totalTransactions})
                        </span>
                      </th>
                      <th
                        style={{
                          width: "250px",
                          textAlign: "center",
                          fontSize: "14px",
                          color: "rgb(16 16 16 / 89%)",
                          borderRight: "1px solid",
                        }}
                      >
                        {cf(Math.round(edx?.nachTransactionsAmt))}{" "}
                        <span style={styles.count}>
                          ({edx?.nachTransactions})
                        </span>
                      </th>
                      <th
                        style={{
                          width: "250px",
                          textAlign: "center",
                          fontSize: "14px",
                          color: "rgb(16 16 16 / 89%)",
                        }}
                      >
                        {edx["amtPercentage"]}{" "}
                        <span style={styles.count}>
                          ({edx?.countPercentage})
                        </span>
                      </th>
                    </th>
                  );
                })}
              </tr>
            </tbody>
          </table>
        ) : (
          <div style={styles?.loading_container}>No data</div>
        )}
      </div>

      {loader === null && monthlyData?.length > 0 && (
        <Button
          className="mt-2"
          onClick={() => {
            handleDownloadCsv();
          }}
        >
          <FileDownloadIcon /> Download
        </Button>
      )}
    </>
  );
}

const styles = {
  table: {
    borderCollapse: "collapse",
    border: "1px solid",
  },
  thead: {
    border: "1px solid",
  },

  th_top_months: {
    border: "1px solid",
    width: "125px",
  },
  th_top_nbfcs: {
    minWidth: "750px",
    textAlign: "center",
    border: "1px solid",
  },
  th_secondary: {
    width: "250px",
    textAlign: "center",
    fontSize: "12px",
    color: "#0000008c",
    borderRight: "1px solid",
    borderCollapse: "collapse",
  },
  loading_container: {
    height: "20vh",
    width: "70vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  count: {
    fontSize: 12,
    color: "gray",
    fontWeight: 500,
  },
};
